import React from 'react';
import EmbeddedModule from './EmbeddedModule';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Network, Cpu, Zap, GitBranch } from 'lucide-react';

const PILLARS = [
  {
    icon: Cpu,
    name: 'Model Risk Management',
    desc: '23 production models · validation pipelines · drift monitors',
    color: 'text-blue-700 bg-blue-50 border-blue-100'
  },
  {
    icon: GitBranch,
    name: 'Multi-Agent Orchestration',
    desc: '185 specialised agents across compliance, AML, FRM, audit & legal',
    color: 'text-indigo-700 bg-indigo-50 border-indigo-100'
  },
  {
    icon: Network,
    name: 'Sentinel Gateway',
    desc: '70+ unified GRC / BFSI / AI Governance APIs · single command center',
    color: 'text-emerald-700 bg-emerald-50 border-emerald-100'
  },
  {
    icon: Zap,
    name: 'Real-time Decisioning',
    desc: 'Sub-200ms anti-fraud, kill-switch, sanctions and DPDP gates',
    color: 'text-amber-700 bg-amber-50 border-amber-100'
  }
];

const AIOrchestration = () => (
  <EmbeddedModule
    eyebrow="AI Governance · Backbone"
    title="AI Orchestration Hub"
    tagline="Single command center for 70+ GRC, BFSI and AI Governance APIs powering Sanmiggrc — model registry, drift, bias, kill-switch, agent routing and compliance enforcement."
    badgeText="Sentinel Gateway"
    accentClass="from-blue-800 via-indigo-700 to-violet-700"
    embedUrl="https://gateways.aisentinelgsuite.com"
    embedTitle="gateways.aisentinelgsuite.com"
    testId="ai-orchestration-page"
    kpis={[
      { label: 'APIs Unified', value: '70+' },
      { label: 'Agents Orchestrated', value: '185' },
      { label: 'Models in Prod', value: '22' },
      { label: 'Decision Latency', value: '<200ms' }
    ]}
  >
    <Card data-testid="ai-orchestration-pillars">
      <CardHeader>
        <CardTitle>Pillars</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {PILLARS.map((p) => {
            const Icon = p.icon;
            return (
              <div key={p.name} className={`border rounded-lg p-4 flex items-start space-x-3 ${p.color}`}>
                <div className="w-10 h-10 rounded-md bg-white/70 border border-white/40 flex items-center justify-center flex-shrink-0">
                  <Icon className="w-5 h-5" />
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-semibold">{p.name}</p>
                  <p className="text-xs opacity-80 mt-1">{p.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  </EmbeddedModule>
);

export default AIOrchestration;
